module.exports = __webpack_public_path__ + "img/maskin.4185a5ca.jpeg";